import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface USPDefinition {
  title: string
  subtitle: string
  imageId: string
}

function useUltraLuxLabels() {
  const intl = useIntl()

  return useMemo(() => ({
    hotels: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'npKMT3pTKx',
          defaultMessage: 'Exceptional 5 & 6 star properties',
          description: 'Ultra lux USP title for exceptional hotel properties',
        }),
        subtitle: intl.formatMessage({
          id: 'oxo85CXAHL',
          defaultMessage: 'Get access to exclusive luxury hotels around the world',
          description: 'Ultra lux USP subtitle for exceptional hotel properties',
        }),
        imageId: 'tujk1y9ccy97sf0dcrk4',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: 'FG3InE6F5+',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'ZXhXuEW0Hm',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: '3W/zCandFb',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux USP title for 24/7 concierge service',
          }),
          subtitle: intl.formatMessage({
            id: '7fUiN+rdsk',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux USP subtitle for 24/7 concierge service',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
    tours: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'J47ie1IJNv',
          defaultMessage: 'Exceptional tours',
          description: 'Ultra lux USP title for exceptional tours',
        }),
        subtitle: intl.formatMessage({
          id: 'BDH0wKzf3g',
          defaultMessage: 'Get access to expertly curated tours, coupled with the world\u2019s most prestigious hotels',
          description: 'Ultra lux USP subtitle for exceptional tours',
        }),
        imageId: 'b6xj75dk8i9wji8fit5ch',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: '4B3WeF9Lg5',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux tours USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'VW/Zo7TgtU',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux tours USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: 'qHf3pvjU0W',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux tours USP title for 24/7 concierge service',
          }),
          subtitle: intl.formatMessage({
            id: 'OrSGe3Z9Qj',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux tours USP subtitle for 24/7 concierge service',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
    cruises: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'MS7hK5kH43',
          defaultMessage: 'Unforgettable cruises',
          description: 'Ultra lux USP title for unforgettable cruises',
        }),
        subtitle: intl.formatMessage({
          id: 'MZ3T4xyz41',
          defaultMessage: 'Get access to sailings onboard the world\u2019s most luxurious ships with unmatched service',
          description: 'Ultra lux USP subtitle for unforgettable cruises',
        }),
        imageId: 'nm8nh9vh6sys7ifvjnf',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: 'WNGTukgyCQ',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux cruises USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'D2dK2Ofyi4',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux cruises USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: 'p70cBj3j3P',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux cruises USP title for 24/7 concierge service',
          }),
          subtitle: intl.formatMessage({
            id: 'a3mBrrNyEr',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux cruises USP subtitle for 24/7 concierge service',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
  }), [intl])
}

export default useUltraLuxLabels
